<template>
  <v-layout>
    <v-store-user-info />

    <h1>{{ $t('regionSelect.title') }}</h1>
    <p class="region-select-question" v-html="$t('regionSelect.intro')"/>
    <a href="#"
       class="button dropdown region-selector-trigger"
       @click.prevent="regionSelectionModalVisible=true"
       v-html="buttonText"/>
    <region-selection-modal v-if="regionSelectionModalVisible"
                            @regionSelectionDraftChanged="onDraftChanged"
                            @close="onClose()"/>
  </v-layout>
</template>

<script>
import VLayout from '../layouts/Default'
import VStoreUserInfo from '../components/user/StoreUserInfo'
import RegionSelectionModal from '../components/modals/RegionSelectorWebshop'
import bodyClassMixin from '../mixins/body-class'
import { NalShop } from '../store/modules/shop/types'

export default {
  name: 'RegionSelect',
  components: {
    VLayout,
    VStoreUserInfo,
    RegionSelectionModal
  },
  mixins: [
    bodyClassMixin
  ],
  data () {
    return {
      regionSelectionModalVisible: false,
      numberOfSelectedRegionsInDraft: this.$store.state.selection.selectedFilterEntities.regions.length
    }
  },
  computed: {
    buttonText () {
      return this.numberOfSelectedRegionsInDraft === 0 ? this.$t('regionSelect.selectRegions') : this.$t('regionSelect.changeRegionSelection')
    }
  },
  mounted: async function () {
    await this.$store.dispatch('shop/switchShop', new NalShop())
    await this.$store.dispatch('shop/fetchBasicFilters')
    await this.$store.dispatch('selection/fetchRegions')
    await this.$store.dispatch('selection/fetchFilters')
  },
  methods: {
    onDraftChanged: function (draft) {
      this.numberOfSelectedRegionsInDraft = draft.length
    },
    onClose: function () {
      this.regionSelectionModalVisible = false
      if (this.$store.state.selection.selectedFilterEntities.regions.length > 0) {
        this.$router.push({ name: 'ProductOverview', lang: 'nl' })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/RegionSelect.vue